import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/logo.png"; // Add your logo here

function Footer() {
  return (
    <footer className="bg-white">
      <div className="flex flex-wrap justify-around lg:px-40 md:px-8 px-4 py-6">
        <div className="flex flex-col items-center mb-6">
          <img src={Logo} alt="Vavuniya Ad Online" className="w-[180px] mb-4" />{" "}
        </div>

        <div className="account flex flex-col mb-6">
          <h2 className="font-bold text-lg md:text-base mb-2">Account</h2>
          <div className="links flex flex-col gap-1 text-sm md:text-base">
            <Link to="/myads">My Account</Link>
            <Link to="/login">Login / Register</Link>
            <Link to="/shop">Shop</Link>
          </div>
        </div>

        <div className="support flex flex-col mb-6">
          <h2 className="font-bold text-lg md:text-base mb-2">Support</h2>
          <div className="flex flex-col gap-1 text-sm md:text-base">
            <p>03, Vairavapuliyankulam, Vavuniya</p>
            <p>northernithub@gmail.com</p>
            <p>+88015-88888-9999</p>
            <div className="flex gap-2 mt-2">
              <Link to="facebook">
                <i className="fa fa-facebook"></i>
              </Link>
              <Link to="whatsapp">
                <i className="fa fa-whatsapp"></i>
              </Link>
              <Link to="instagram">
                <i className="fa fa-instagram"></i>
              </Link>
              <Link to="linkedin">
                <i className="fa fa-linkedin" aria-hidden="true"></i>
              </Link>
              <Link to="youtube">
                <i className="fa fa-youtube"></i>
              </Link>
            </div>
          </div>
        </div>

        <div className="quick-links flex flex-col mb-6">
          <h2 className="font-bold text-lg md:text-base mb-2">Quick Links</h2>
          <div className="links flex flex-col gap-1 text-sm md:text-base">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>
      </div>

      <div className="bg-primary text-black font-bold text-center py-2 text-xs md:text-sm">
        &copy; Copyright Nit Add 2022. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
